// extracted by mini-css-extract-plugin
export default {"root":"MainTabs_root__BetOc","stuck":"MainTabs_stuck__8yjy0","content":"MainTabs_content__0Lez0","tab":"MainTabs_tab__U9qXt","is-selected":"MainTabs_is-selected__mlMhs"};